module.exports = __webpack_public_path__ + "static/media/tool-01.9734e07f.png";